var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgDropdownOutline20 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.16709 7.2781C4.42771 6.95615 4.89998 6.90644 5.22192 7.16706L10 11.035L14.7781 7.16706C15.1001 6.90644 15.5723 6.95615 15.833 7.2781C16.0936 7.60004 16.0439 8.07231 15.7219 8.33293L10.4719 12.5829C10.1968 12.8057 9.80329 12.8057 9.52813 12.5829L4.27813 8.33293C3.95618 8.07231 3.90647 7.60004 4.16709 7.2781Z",
  fill: "currentColor"
})));
export { SvgDropdownOutline20 as ReactComponent };